'use client';

import { MutableRefObject, use, useRef } from 'react';
import { useDraggable } from 'react-use-draggable-scroll';

import { TrendingAuthorListProps } from '../types';

import AuthorListCard from './AuthorListCard';
import AuthorListCardListContainer from './AuthorListCardListContainer';

const AuthorListCardList = ({
  trendingAuthorsPromise,
}: TrendingAuthorListProps) => {
  const boxRef = useRef<HTMLDivElement>(null);
  const { events: draggableScrollEvents } = useDraggable(
    boxRef as MutableRefObject<HTMLElement>
  );
  const trendingAuthors = use(trendingAuthorsPromise);

  return (
    <AuthorListCardListContainer
      ref={boxRef}
      {...draggableScrollEvents}
      data-testid="landing-trending-authors-list"
    >
      {trendingAuthors.map((author) => (
        <AuthorListCard key={author.id} {...author} />
      ))}
    </AuthorListCardListContainer>
  );
};

export default AuthorListCardList;
